import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";

import artData from "./WebsiteContent/ArtContent.json";
import travelData from "./WebsiteContent/TravellingContent.json";
import recipeData from "./WebsiteContent/RecipeContent.json";
import technologyData from "./WebsiteContent/TechnologyContent.json";

export default function PhotoDetail() {
  const { category, id } = useParams();
  const navigate = useNavigate();

  const contentMap = {
    art: artData,
    travel: travelData,
    recipes: recipeData,
    technology: technologyData
  };

  const selectedData = contentMap[category];

  if (!selectedData) {
    return (
      <div className="container py-5 text-center">
        <h2>Invalid category</h2>
        <p>No data found for category "{category}".</p>
        <button onClick={() => navigate(-1)} className="btn btn-secondary">
          Go Back
        </button>
      </div>
    );
  }
  const photos = selectedData.map((photo) => ({
    ...photo,
    src: photo.src // directly use /Photos/... paths
  }));


  const photo = photos.find((p) => String(p.id) === String(id));

  if (!photo) {
    return (
      <div className="container py-5 text-center">
        <h2>Photo not found</h2>
        <button onClick={() => navigate(-1)} className="btn btn-secondary">
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="container py-6 photo-detail">
      <button onClick={() => navigate(-1)} className="btn btn-secondary back-btn">
        &lt; Back
      </button>

      <div className="card photo-card">
        <div className="photo-image-container">
          <img
            src={photo.src}
            alt={photo.alt || "Photo"}
            className="photo-image"
          />
        </div>

        <div className="card-body">
          <h3 className="card-title mb-3">{photo.title }</h3>

          {photo.largeCaption && (
            <div className="card-text photo-description">
              <ReactMarkdown>{photo.largeCaption}</ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}